import React from "react";
import Banner from "../components/Banner";
import PMDocumentMatrix from "../components/PMDocumentMatrix";



const ReportPage: React.FC = () => {
    return (
        <>
            <Banner current="report" />

            <div data-testid="report-page" className="p-6 max-w-screen-xl mx-auto mb-6">
                <h1 className="text-2xl font-bold text-start mb-4">
                    Quarterly Report Viewer
                </h1>
                <div style={{
                    height: "70vh",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    // p:2,
                }}   >
                    <PMDocumentMatrix />
                </div>
            </div>
        </>
    )
};

export default ReportPage;